import { useState } from "react";
import { PropTypes } from "base/react-libs";
import { daysFromNow } from "apps/tasks/utils/utils";
import { setTaskCompletion } from "apps/tasks/utils/tasks-actions";
import { trackJourneysAction } from "apps/journeys/utils/helpers/mixpanel";
import { Button, useOpenClose } from "@evertrue/et-components";
import JourneyContactCard from "apps/journeys/components/journey-contact-card";
import TaskRowActionButton from "./task-row-action-button";
import CompleteTaskToggle from "apps/tasks/components/complete-task-toggle";
import EndJourneyModal from "apps/journeys/components/modals/end-journey-modal";

const TaskRowDetails = ({
  step,
  journey,
  isFinalStep,
  openContactSummary,
  optionalStateManagementFunction = () => {},
}) => {
  const [isModalOpen, openModal, closeModal] = useOpenClose();
  const [taskToEnd, setTaskToEnd] = useState({});

  const completeTaskStateUpdates = async (task, step) => {
    const markComplete = task.completed_at ? false : true;
    const type = markComplete ? "complete_step" : "uncomplete_step";
    trackJourneysAction("complete_toggle", type);
    const { completed_at } = await setTaskCompletion(task, markComplete);
    optionalStateManagementFunction("completionToggle", { task, step, completed_at });
  };

  const handleCompletionClick = async (task) => {
    if (isFinalStep && !task.completed_at) {
      setTaskToEnd(task);
      isModalOpen ? closeModal() : openModal();
      return;
    }
    completeTaskStateUpdates(task, step);
  };

  const overdueMessage = (task) => {
    const { due_date } = task;
    if (!due_date) return null;
    const time = new Date(due_date).getTime() / 1000;
    const due = daysFromNow(time);
    if (due.msg) return <div className="journeys-task-table-row--details--due-date-text">{due.msg}</div>;
  };

  const { tasks } = step;

  return (
    <div>
      {tasks &&
        tasks.map((task) => {
          return (
            <div key={`task-record-${task.id}`} className="journeys-task-table-row--details">
              <div>
                <CompleteTaskToggle task={task} size="small" onClick={handleCompletionClick} />
                <JourneyContactCard contact={task.contact} currentJourney={journey} />
              </div>
              <div>
                {overdueMessage(task)}
                <TaskRowActionButton
                  journey={journey}
                  step={step}
                  task={task}
                  optionalStateManagementFunction={optionalStateManagementFunction}
                />
                <Button
                  disabled={!task.contact}
                  onClick={() => {
                    trackJourneysAction("view_link");
                    const { contact = null } = task;
                    openContactSummary(contact);
                  }}
                  type="simple"
                >
                  View
                </Button>
              </div>
            </div>
          );
        })}
      <EndJourneyModal
        isOpen={isModalOpen}
        onClose={closeModal}
        task={taskToEnd}
        step={step}
        completeTaskStateUpdates={completeTaskStateUpdates}
        currentJourney={journey}
        optionalStateManagementFunction={optionalStateManagementFunction}
      />
    </div>
  );
};

TaskRowDetails.propTypes = {
  step: PropTypes.object,
  tasks: PropTypes.array,
  journey: PropTypes.object,
  isFinalStep: PropTypes.bool,
  openContactSummary: PropTypes.func,
  optionalStateManagementFunction: PropTypes.func,
};

export default TaskRowDetails;
